var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-full relative" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.searchInputValue,
          expression: "searchInputValue"
        }
      ],
      staticClass:
        "w-full h-18 u-body-md px-5 py-3 border-1 border-primary rounded-lg transition-all outline-none hover:shadow-why-benefits-card text-black disabled:bg-white disabled:border-grey-300 disabled:text-grey-400 disabled:shadow-none",
      attrs: {
        placeholder: _vm.placeholder,
        disabled: !_vm.ready || _vm.searching
      },
      domProps: { value: _vm.searchInputValue },
      on: {
        input: [
          function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.searchInputValue = $event.target.value
          },
          _vm.inputHandler
        ],
        keypress: _vm.inputKeypressHandler
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "searchButtonWrapper",
        staticClass: "absolute top-1/2 -translate-y-1/2 right-3"
      },
      [
        _c(
          "button",
          {
            staticClass:
              "inline-flex relative flex-nowrap items-center group focus:outline-none bg-primary-400 hover:bg-white text-grey-900 rounded-lg h-12 px-2 xs:px-4 py-3 border-2 border-solid border-primary-400 transition-colors duration-200 ease-in-out disabled:bg-grey-200 disabled:text-grey-600 disabled:border-0 disabled:cursor-not-allowed",
            attrs: { type: "button", disabled: !_vm.ready || _vm.searching },
            on: { click: _vm.searchHandler }
          },
          [
            _c("span", {
              staticClass:
                "absolute -inset-1.5 opacity-0 group-focus:opacity-100 border-2 border-grey-900 border-solid rounded-lg transition-opacity duration-200 ease-in-out pointer-events-none"
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "u-body-md font-bold border-b-2 border-solid border-transparent group-hover:border-current transition-colors duration-200 ease-in-out group-disabled:border-transparent"
              },
              [_vm._v("\n        Search\n      ")]
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _vm.error !== ""
      ? _c("p", {
          staticClass: "absolute -bottom-6 left-0 ml-5 text-xs text-error",
          domProps: { innerHTML: _vm._s(_vm.error) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }